import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  QButton,
  useCurrentUser,
  useToastProvider,
} from '@qualio/ui-components';

import { documentApi } from '../../../../../api/document';
import { hasReviewed } from '../../../../../util/CurrentUser';
import { ButtonGroupContext } from '../../../Contexts/ButtonGroupContext';
import { DocumentOverviewContext } from '../../Context';
import { shouldRenderMarkAsReviewedButton } from '../../RenderLogic';

export const MarkAsReviewedButton = () => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const { qualioDocument, refetchDocumentOverviewData } = useContext(
    DocumentOverviewContext,
  );
  const { isDisabled, setDisabled } = useContext(ButtonGroupContext);
  const { showToast } = useToastProvider();
  const [isReviewing, setIsReviewing] = useState(false);

  const commonToastProps = {
    id: 'mark-as-reviewed-toast',
    replace: true,
  };

  const handleMarkAsReviewed = () => {
    setDisabled(true, setIsReviewing);
    documentApi
      .review(qualioDocument.id)
      .then(() => {
        refetchDocumentOverviewData();
        setDisabled(false, setIsReviewing);
        showToast({
          'data-cy': 'mark-as-reviewed-button-notify-success-toast',
          ...commonToastProps,
          description: t('success.yourReviewHasBeenSubmitted'),
          status: 'success',
          title: t('notifications.success'),
        });
      })
      .catch((e) => {
        setDisabled(false, setIsReviewing);
        const failureMessage =
          e.response?.data?.message ||
          t('documentActions.failedToMarkAsReviewed');
        showToast({
          'data-cy': 'mark-as-reviewed-button-notify-error-toast',
          ...commonToastProps,
          status: 'error',
          title: t('notifications.error'),
          description: failureMessage,
        });
        setIsReviewing(false);
      });
  };

  if (!shouldRenderMarkAsReviewedButton(qualioDocument, currentUser)) {
    return null;
  }

  return (
    <QButton
      isLoading={isReviewing}
      variant="solid"
      onClick={handleMarkAsReviewed}
      data-cy="doc-overview-mark-as-reviewed-button"
      isDisabled={
        hasReviewed(currentUser, qualioDocument) || isReviewing || isDisabled
      }
    >
      {t('buttons.markAsReviewed')}
    </QButton>
  );
};
